import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const listOrders = (params) => {
    return api.get(ENDPOINTS.ORDERS.LIST, { params });
};

export const getOrderDetails = (orderNumber) => {
    return api.get(ENDPOINTS.ORDERS.DETAIL(orderNumber));
};

export const cancelOrder = (orderNumber, data) => {
    return api.post(ENDPOINTS.ORDERS.CANCEL(orderNumber), data);
};

export const requestReturn = (orderNumber, data) => {
    return api.post(ENDPOINTS.ORDERS.RETURN(orderNumber), data);
};

export const getReturnReasons = () => {
    return api.get(ENDPOINTS.ORDERS.RETURN_REASONS);
};

export const getOrderInvoice = (orderNumber) => {
    return api.get(ENDPOINTS.ORDERS.INVOICE(orderNumber), {
        responseType: "blob",
    });
};

export const trackGuestOrder = (token) => {
    return api.get(ENDPOINTS.ORDERS.TRACK(token));
};
